import React, { useState } from "react";
import { Pencil, ChevronDown } from "lucide-react";
import AddRemarkForm from "./AddRemarkForm";
import RemarkList from "./RemarkList";
import UsePermissionsClaim from "../../CustomHooks/UsePermissionsClaim";

const Remarks = ({
  remarkList,
  dataId,
  apiUrl,
  setViewDetails,
  currenExpenseTab,
}) => {
  const [OpenRemarkList, setOpenRemarkList] = useState(false);
  const [showAddRemark, setShowAddRemark] = useState(false);

  const { checkPermission } = UsePermissionsClaim();
  const permAddRemark = checkPermission("add_remark");

  const handleRemarkList = () => {
    setOpenRemarkList((prev) => !prev);
    setShowAddRemark(false);
  };

  const handleAddRemark = () => {
    setShowAddRemark(true);
    setOpenRemarkList(false);
  };

  return (
    <>
      <div className="main-remark-container">
        <button
          className={`text-dark-blue 2xs:max-lg:text-sm ${
            remarkList ?? "cursor-pointer"
          } p-4 w-full text-left relative`}
          onClick={remarkList ? handleRemarkList : undefined}
        >
          <span className="font-semibold font-figtree">
            Remarks <span>({`${remarkList ? remarkList.length : 0}`})</span>
          </span>
          {remarkList && (
            <ChevronDown
              color="#021472"
              size={30}
              className={`right-5 absolute ${
                OpenRemarkList ? "rotate-180 top-3" : "top-4"
              }`}
            />
          )}
        </button>
        {permAddRemark && (
          <p
            className={`absolute top-4 ${
              remarkList ? "right-10 2xs:max-sm:right-12" : "right-4"
            }`}
          >
            <button
              onClick={handleAddRemark}
              className="add-remark-btn dark-blue-filter"
            >
              <Pencil color="white" size={14} className="mr-1" />
              Add Remark
            </button>
          </p>
        )}
        <AddRemarkForm
          dataId={dataId}
          apiUrl={apiUrl}
          setViewDetails={setViewDetails}
          showAddRemark={showAddRemark}
          setShowAddRemark={setShowAddRemark}
          setOpenRemarkList={setOpenRemarkList}
          currenExpenseTab={currenExpenseTab}
        />
        <RemarkList
          remarkList={remarkList}
          OpenRemarkList={OpenRemarkList}
          dataId={dataId}
          setViewDetails={setViewDetails}
        />
      </div>
    </>
  );
};
export default Remarks;
